/* eslint-disable react-hooks/exhaustive-deps */

import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { formatMessage } from "@local/legacy-utils/i18nHelper";
import Table from "@local/components/table";
import { getAuditReportsList, getCountriesList, getAgenciesList, createAuditReport } from "@local/actions";
import { getAuditReportsColumns } from "../../utils/columns";
import { adaptCountries } from "@local/utils/adapters";
import AuditDetailsModal from "./components/modal";
import Breadcrumb from "@local/components/breadcrumb";
import { auditDetailsNav } from "../../utils/constants";
import Button from "@local/components/button";
import AddAuditModal from "./components/addAuditModal";
import { reset } from "redux-form";
import moment from "moment";
import { toast } from "react-toastify";
import i18n from "@local/i18next/i18n";
import { getErrors } from "@local/utils";

const Audit = ({ getAuditReports, countries, getCountries, getAgencies, partnerId, onAuditSubmit }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isAddAuditModalVisible, setIsAddAuditModalVisible] = useState(false);
  const [shouldRefresh, setShouldRefresh] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const dispatch = useDispatch();
  const handleChange = (event, tabIndex) => {
    setSelectedTabIndex(tabIndex);
  };

  const tabs = auditDetailsNav;

  useEffect(() => {
    getAgencies();
    getCountries();
  }, []);

  const onClickOpenModal = (row) => {
    setSelectedRow(row);
    setIsModalVisible(true);
  };
  const onClickCloseModal = () => {
    setIsModalVisible(false);
    setSelectedRow(null);
  };

  const onCloseCreateAuditModal = () => {
    setIsAddAuditModalVisible(false);
    dispatch(reset("addAuditModalForm"));
  };

  const onAuditSubmitHandler = async (params) => {
    try {
      await onAuditSubmit(params);
      onCloseCreateAuditModal();
      toast.success(i18n.t("Audit report created successfully"));
      setShouldRefresh(true);
    } catch (e) {
      const er = getErrors(e);
      const errors = er.join(", ");
      toast.error(i18n.t("Failed to create audit report, reason:\n" + errors));
    }
  };

  const afterRefresh = () => {
    setShouldRefresh(false);
  };

  return (
    <>
      <Breadcrumb
        items={[
          {
            id: 1,
            label: formatMessage({
              id: "pages.partner.details.cmp.risk.cmp.audit.idx.dashboardTitle",
            }),
            url: `/partner/${partnerId}/risk/dashboard`,
          },
          {
            id: 2,
            label: i18n.t("Assurance Reports"),
            url: `/partner/${partnerId}/risk/audit`,
          },
        ]}
      />
      <Table
        key="risk_audits_list"
        id="risk_audits_list"
        title={i18n.t("Assurance Reports")}
        shouldRefresh={shouldRefresh}
        afterRefresh={afterRefresh}
        columns={getAuditReportsColumns(countries, onClickOpenModal)}
        fetchFunction={getAuditReports}
        onClickOpenModal={onClickOpenModal}
        actions={[<Button onClick={() => setIsAddAuditModalVisible(true)} text={i18n.t("Add Report")} />]}
      />
      <AuditDetailsModal audit={selectedRow} isOpen={isModalVisible} onClose={onClickCloseModal} handleChange={handleChange} tabs={tabs} index={selectedTabIndex} />
      <AddAuditModal isOpen={isAddAuditModalVisible} onClose={onCloseCreateAuditModal} onAuditSubmit={onAuditSubmitHandler} countries={countries} />
    </>
  );
};

Audit.propTypes = {};

const mapStateToProps = (state) => ({
  agencies: state?.agenciesList?.data?.data?.results ?? [],
  countries: adaptCountries(state?.countriesList?.data?.data ?? {}),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  onAuditSubmit: async (params) => {
    let objToSend = {
      partner: ownProps.partnerId,
      type: params.type,
      report_type: params.report_type,
      report_name: params.report_name,
      operating_country: params.operating_country,
      risk_level: params.risk_level,
      opinion: params.opinion,
      key_findings: params.key_findings,
      compliance: params.compliance,
      recommendations: params.recommendations,
      ineligible_expenses: params.ineligible_expenses,
      attachments: params.attachments.map((attachment) => attachment.id),
      audit_date: moment(params.audit_date).format("YYYY-MM-DD"),
      audit_date_from: moment(params.audit_date_period[0]).format("YYYY-MM-DD"),
      audit_date_to: moment(params.audit_date_period[1]).format("YYYY-MM-DD"),
    };
    return await dispatch(createAuditReport(objToSend));
  },
  getAuditReports: (params) => dispatch(getAuditReportsList({ ...params, partner: ownProps.partnerId })),
  getCountries: () => dispatch(getCountriesList()),
  getAgencies: (params) => dispatch(getAgenciesList(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Audit);
